const Welcome = () => import('~/pages/welcome').then(m => m.default || m);
const Login = () => import('~/pages/auth/login').then(m => m.default || m);
const Register = () => import('~/pages/auth/register').then(m => m.default || m);
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m);
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m);
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m);

const Home = () => import('~/pages/home').then(m => m.default || m);
const Settings = () => import('~/pages/settings/index').then(m => m.default || m);
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m);
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m);

const MechanicNav = () => import('~/pages/mechanic/nav').then(m => m.default || m);
const MechanicIndex = () => import('~/pages/mechanic/index').then(m => m.default || m);
const MechanicNew = () => import('~/pages/mechanic/new').then(m => m.default || m);
const MechanicAssigned = () => import('~/pages/mechanic/assigned').then(m => m.default || m);
const MechanicRepair = () => import('~/pages/mechanic/repair').then(m => m.default || m);
const MechanicRelease = () => import('~/pages/mechanic/release').then(m => m.default || m);
const MechanicEnded = () => import('~/pages/mechanic/ended').then(m => m.default || m);
const MechanicArchive = () => import('~/pages/mechanic/archive').then(m => m.default || m);
const MechanicCanceled = () => import('~/pages/mechanic/canceled').then(m => m.default || m);

const MechanicInfoNav = () => import('~/pages/mechanic/info/nav').then(m => m.default || m);
const MechanicInfoDetails = () => import('~/pages/mechanic/info/details').then(m => m.default || m);

const ConfigurationNav = () => import('~/pages/configuration/nav').then(m => m.default || m);
const ConfigurationIndex = () => import('~/pages/configuration/index').then(m => m.default || m);
const ConfigurationUsers = () => import('~/pages/configuration/users/index').then(m => m.default || m);
const ConfigurationUsersEdit = () => import('~/pages/configuration/users/edit').then(m => m.default || m);
const ConfigurationUsersDelete = () => import('~/pages/configuration/users/delete').then(m => m.default || m);
const ConfigurationPermissions = () => import('~/pages/configuration/permissions/index').then(m => m.default || m);
const ConfigurationCompanies = () => import('~/pages/configuration/companies/index').then(m => m.default || m);
const ConfigurationCompaniesEdit = () => import('~/pages/configuration/companies/edit').then(m => m.default || m);
const ConfigurationCompaniesCreate = () => import('~/pages/configuration/companies/create').then(m => m.default || m);
const ConfigurationCompaniesUsers = () => import('~/pages/configuration/companies/users').then(m => m.default || m);
const ConfigurationCompaniesContracts= () => import('~/pages/configuration/companies/contracts').then(m => m.default || m);
const ConfigurationCompaniesAddContract= () => import('~/pages/configuration/companies/add_contract').then(m => m.default || m);
const ConfigurationCompaniesEditContract= () => import('~/pages/configuration/companies/edit_contract').then(m => m.default || m);
const ConfigurationCompaniesDeleteContract= () => import('~/pages/configuration/companies/delete_contract').then(m => m.default || m);
const ConfigurationSystems = () => import('~/pages/configuration/systems/index').then(m => m.default || m);
const ConfigurationSystemsEdit = () => import('~/pages/configuration/systems/edit').then(m => m.default || m);

const InjuryNav = () => import('~/pages/injury/nav').then(m => m.default || m);
const InjuryIndex = () => import('~/pages/injury/index').then(m => m.default || m);
const InjuryNew = () => import('~/pages/injury/new').then(m => m.default || m);
const InjuryAssigned = () => import('~/pages/injury/assigned').then(m => m.default || m);
const InjuryRepair = () => import('~/pages/injury/repair').then(m => m.default || m);
const InjuryRelease = () => import('~/pages/injury/release').then(m => m.default || m);
const InjuryEnded = () => import('~/pages/injury/ended').then(m => m.default || m);
const InjuryVerified = () => import('~/pages/injury/verified').then(m => m.default || m);
const InjuryArchive = () => import('~/pages/injury/archive').then(m => m.default || m);
const InjuryCanceled = () => import('~/pages/injury/canceled').then(m => m.default || m);
const InjuryTotal = () => import('~/pages/injury/total').then(m => m.default || m);
const InjuryUnregistered = () => import('~/pages/injury/unregistered').then(m => m.default || m);

const InjuryInfoNav = () => import('~/pages/injury/info/nav').then(m => m.default || m);
const InjuryInfoDetails = () => import('~/pages/injury/info/details').then(m => m.default || m);

const SettlementNav = () => import('~/pages/settlement/nav').then(m => m.default || m);
const SettlementIndex = () => import('~/pages/settlement/index').then(m => m.default || m);

const FleetsList = () => import('~/pages/fleets/list').then(m => m.default || m);
const VehiclesList = () => import('~/pages/vehicles/list').then(m => m.default || m);
const ServicesList = () => import('~/pages/services/list').then(m => m.default || m);

export default [
    {path: '/', name: 'welcome', component: Welcome},
    {path: '/home', name: 'home', component: Home},

    {path: '/login', name: 'login', component: Login},
    {path: '/register', name: 'register', component: Register},
    {path: '/password/reset', name: 'password.request', component: PasswordEmail},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

    {
        path: '/settings',
        component: Settings,
        children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {path: 'profile', name: 'settings.profile', component: SettingsProfile},
            {path: 'password', name: 'settings.password', component: SettingsPassword}
        ]
    },

    {
        path: '/mechanic/info',
        component: MechanicInfoNav,
        children: [
            {path: 'details/:id', name: 'mechanic.info.details', component: MechanicInfoDetails}
        ]
    },

    {
        path: '/mechanic',
        component: MechanicNav,
        children: [
            {path: '', name: 'mechanic', component: MechanicIndex},
            {path: 'new', name: 'mechanic.new', component: MechanicNew},
            {path: 'assigned', name: 'mechanic.assigned', component: MechanicAssigned},
            {path: 'repair', name: 'mechanic.repair', component: MechanicRepair},
            {path: 'release', name: 'mechanic.release', component: MechanicRelease},
            {path: 'ended', name: 'mechanic.ended', component: MechanicEnded},
            {path: 'archive', name: 'mechanic.archive', component: MechanicArchive},
            {path: 'canceled', name: 'mechanic.canceled', component: MechanicCanceled}
        ]
    },

    {
        path: '/injuries/info',
        component: InjuryInfoNav,
        children: [
            {path: 'details/:id', name: 'injuries.info.details', component: InjuryInfoDetails}
        ]
    },

    {
        path: '/injuries',
        component: InjuryNav,
        children: [
            {path: '', name: 'injuries', component: InjuryIndex},
            {path: 'new', name: 'injuries.new', component: InjuryNew},
            {path: 'assigned', name: 'injuries.assigned', component: InjuryAssigned},
            {path: 'repair', name: 'injuries.repair', component: InjuryRepair},
            {path: 'release', name: 'injuries.release', component: InjuryRelease},
            {path: 'ended', name: 'injuries.ended', component: InjuryEnded},
            {path: 'verified', name: 'injuries.verified', component: InjuryVerified},
            {path: 'archive', name: 'injuries.archive', component: InjuryArchive},
            {path: 'canceled', name: 'injuries.canceled', component: InjuryCanceled},
            {path: 'total', name: 'injuries.total', component: InjuryTotal},
            {path: 'unregistered', name: 'injuries.unregistered', component: InjuryUnregistered},
        ]
    },


    {
        path: '/settlements',
        component: SettlementNav,
        children: [
            {path: '', name: 'settlements', component: SettlementIndex}
        ]
    },

    {path: '/fleets/list', name: 'fleets.list', component: FleetsList},
    {path: '/vehicles/list', name: 'vehicles.list', component: VehiclesList},
    {path: '/services/list', name: 'services.list', component: ServicesList},

    {
        path: '/configuration',
        component: ConfigurationNav,
        children: [
            {path: '', name: 'configuration', component: ConfigurationIndex},
            {path: 'users', name: 'configuration.users', component: ConfigurationUsers},
            {path: 'users/edit/:id', name: 'configuration.user.edit', component: ConfigurationUsersEdit},
            {path: 'users/delete/:id', name: 'configuration.user.delete', component: ConfigurationUsersDelete},
            {path: 'permissions', name: 'configuration.permissions', component: ConfigurationPermissions},
            {path: 'companies', name: 'configuration.companies', component: ConfigurationCompanies},
            {path: 'companies/edit/:id', name: 'configuration.companies.edit', component: ConfigurationCompaniesEdit},
            {path: 'companies/create', name: 'configuration.companies.create', component: ConfigurationCompaniesCreate},
            {path: 'companies/users/:id', name: 'configuration.companies.users', component: ConfigurationCompaniesUsers},
            {path: 'companies/contracts/:id', name: 'configuration.companies.contracts', component: ConfigurationCompaniesContracts},
            {path: 'companies/contract/add/:id', name: 'configuration.companies.add_contract', component: ConfigurationCompaniesAddContract},
            {path: 'companies/contract/edit/:id', name: 'configuration.companies.edit_contract', component: ConfigurationCompaniesEditContract},
            {path: 'companies/contract/delete/:id', name: 'configuration.companies.delete_contract', component: ConfigurationCompaniesDeleteContract},
            {path: 'systems', name: 'configuration.systems', component: ConfigurationSystems},
            {path: 'systems/edit/:id', name: 'configuration.systems.edit', component: ConfigurationSystemsEdit}
        ]
    },
    {path: '*', component: NotFound}
]




// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js